<div class="new-item-modal">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'crm.modal.title' | translate }}
    </h5>
    <div class="close-icon" type="button" aria-label="Close" (click)="dismissModal()">
      <mat-icon>close</mat-icon>
    </div>
  </div>

  <div class="modal-body extra-large">
    <div class="fw-bold mb-3">
      {{ 'crm.modal.connect-explain' | translate }} <span role="link" tabindex="0" (click)="openAuthorization($event)" (keydown.enter)="openAuthorization($event)" class="authorization-link">cliquez sur ce lien</span>.
    </div>
    <div class="instruction-title"><span class="underlined">{{ 'crm.modal.instruction-title' | translate }}</span><span> ?</span></div>
    <div class="instruction">
      {{ 'crm.modal.instruction-prefix' | translate }}
      <br>
      {{ 'crm.modal.instruction-suffix' | translate }}
      <a [href]="mailtoHref">equipecsm&#64;explain.fr</a>
      {{ 'crm.modal.contact' | translate }}
    </div>
  </div>

  <div class="modal-footer justify-content-end">
    <button class="ex-btn-strong ex-btn" (click)="dismissModal()">
      <span class="fw-bold align-self-center">{{ 'button.close' | translate }}</span>
    </button>
  </div>
</div> 